import { Card } from '../../components/ui/card';
import { Calendar, MapPin, Clock, Users, ArrowRight } from 'lucide-react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../components/ui/tabs';
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "../ui/carousel";
import { Maximize2 } from "lucide-react";
import FullscreenImageModal from "../home/FullscreenImageModal";
import { ImageWithFallback } from '../home/ImageWithFallback';
import pavamanaHomaImages from "../../assets/img/Events/PavamanaHome";
//import dashalakshaGayatriJapaYagnaImages from "../../assets/img/Events/DashalakshaGayatriJapaYagna";
import ParjanyaJapaAndHoma from '../../assets/img/Events/ParjanyaJapaAndHoma';
import mahaRudraYagaImages from "../../assets/img/Events/MahaRudraYaga";
import sriRamaTarkaHomaImages from "../../assets/img/Events/SriRamaTarakaHoma";
import UchitaRaktadanaShibira from '../../assets/img/Events/UchitaRaktadanaShibira';
import AkhilaKarnatakaBramhanaMahasabha from '../../assets/img/Events/AkhilaKarnatakaBramhanaMahasabha';
import SachidanadaMurthiAbinandana from '../../assets/img/Events/SachidanadaMurthiAbinandana';
import AdhikaraPadagrahana from '../../assets/img/Events/AdhikaraPadagrahana';
import KannadaRajyotsavaAndCalendarRelease2024 from '../../assets/img/Events/KannadaRajyostavaAndCalanderBidufade/2024';
import KannadaRajyotsavaAndCalendarRelease2025 from '../../assets/img/Events/KannadaRajyostavaAndCalanderBidufade/2025/kannadaRajyostava 2025';
import KannadaRajyotsavaCulturalActivities2025 from '../../assets/img/Events/KannadaRajyostavaAndCalanderBidufade/2025/CulturalActivities';
import AKBMSSuvarnaSambhramaVishwamitra from '../../assets/img/Events/AKBMSSuvarnaVishvamitra';
import MaghaSnana2024 from '../../assets/img/Events/MaghaSnana/2024';
import Maghasnana2025 from '../../assets/img/Events/MaghaSnana/2025';
import MahaRudraParayana from '../../assets/img/Events/MaharudraParayana';
import ArunaHoma2024 from '../../assets/img/Events/ArunaHoma/ArunaHoma2024';
//import SanghadaKacheriUdgatanane from '../../assets/img/Events/SanghadaKacheriUdgatane';
import SangadaVarshikaMahasabhi from '../../assets/img/Events/SangadaVarshikaMahasabhi';
import MahilaSammelanaAbhijathe from '../../assets/img/Events/MahilaSammelanaAbhijathe';
//import PrathibaPuraskara2010 from '../../assets/img/Events/PratibhaPuraskara/2010';
//import PrathibaPuraskara2011 from '../../assets/img/Events/PratibhaPuraskara/2011';
import PrathibaPuraskara2012 from '../../assets/img/Events/PratibhaPuraskara/2012';
import PrathibaPuraskara2013 from '../../assets/img/Events/PratibhaPuraskara/2013';
import PrathibaPuraskara2014 from '../../assets/img/Events/PratibhaPuraskara/2014';
import PrathibaPuraskara2015 from '../../assets/img/Events/PratibhaPuraskara/2015';
import PrathibaPuraskara2016 from '../../assets/img/Events/PratibhaPuraskara/2016';
// import PrathibaPuraskara2017 from '../../assets/img/Events/PratibhaPuraskara/2017';
// import PrathibaPuraskara2018 from '../../assets/img/Events/PratibhaPuraskara/2018';
// import PrathibaPuraskara2019 from '../../assets/img/Events/PratibhaPuraskara/2019';
// import PrathibaPuraskara2020 from '../../assets/img/Events/PratibhaPuraskara/2020';
// import PrathibaPuraskara2021 from '../../assets/img/Events/PratibhaPuraskara/2021';
// import PrathibaPuraskara2022 from '../../assets/img/Events/PratibhaPuraskara/2022';
// import PrathibaPuraskara2023 from '../../assets/img/Events/PratibhaPuraskara/2023';
// import PrathibaPuraskara2024 from '../../assets/img/Events/PratibhaPuraskara/2024';
import PrathibaPuraskara2025 from '../../assets/img/Events/PratibhaPuraskara/2025';
import { useState } from 'react';


const EventsComponent = () => {
    const [openModal, setOpenModal] = useState(false);
    const [selectedImages, setSelectedImages] = useState<string[]>([]);

    const openFullscreen = (images: string[]) => {
        setSelectedImages(images);
        setOpenModal(true);
    };

    const upcomingEvents = [
        {
            title: 'ಐಟಿಬಿಟಿ ಮೇಳ',
            date: '2026',
            time: '',
            location: 'ಚಿಂತಾಮಣಿ',
            category: 'Festival',
            attendees: '',
            image: 'https://images.unsplash.com/photo-1590906424086-3dbc808fd54b?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxpbmRpYW4lMjBmZXN0aXZhbCUyMGNlcmVtb255fGVufDF8fHx8MTc2MzM2MDAxNXww&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral',
            description: 'ಚಿಂತಾಮಣಿ ಬ್ರಾಹ್ಮಣ ಮಹಾಸಭಾ ವತಿಯಿಂದ ತಾಲ್ಲೂಕಿನ ವಿಪ್ರರಿಗೆ ಐಟಿ–ಬಿಟಿ ಮೇಳ ಹಮ್ಮಿಕೊಂಡಿದ್ದೇವೆ. ಎಲ್ಲರೂ ಇದನ್ನು ಸದ್ವಿನಿಯೋಗಪಡಿಸಿಕೊಳ್ಳಬೇಕೆಂದು ವಿನಂತಿ. ದಿನಾಂಕವನ್ನು ಶೀಘ್ರದಲ್ಲೇ ಪ್ರಕಟಿಸಲಾಗುವುದು.',
            highlights: ['Traditional rituals', 'Cultural performances', 'Community feast', 'Kids activities'],
        },
    ];

    const pastEvents = [
        {
            title: 'ಕನ್ನಡ ರಾಜ್ಯೋತ್ಸವ ಮತ್ತು ಕ್ಯಾಲೆಂಡರ್ ಬಿಡುಗಡೆ',
            date: 'Nov 30, 2025',
            category: 'Cultural',
            description: '30/11/2025 ರಂದು  ಚಿಂತಾಮಣಿ ತಾಲ್ಲೂಕು ಬ್ರಾಹ್ಮಣ ಮಹಾಸಭಾದ ವತಿಯಿಂದ ನಡೆದ 2026 ಕ್ಯಾಲೆಂಡರ್ ಬಿಡುಗಡೆ ಮತ್ತು ಕನ್ನಡ ರಾಜ್ಯೋತ್ಸವ, ನಗೆ ಹಬ್ಬದ ಕಾರ್ಯಕ್ರಮ.',
            images: KannadaRajyotsavaAndCalendarRelease2025,
        },
        {
            title: 'ಸಾಂಸ್ಕೃತಿಕ ಕಾರ್ಯಕ್ರಮಗಳು',
            date: 'Nov 30, 2025',
            category: 'Cultural',
            description: 'ಕನ್ನಡ ರಾಜ್ಯೋತ್ಸವ ಅಂಗವಾಗಿ ನಡೆದ ಸಾಂಸ್ಕೃತಿಕ ಕಾರ್ಯಕ್ರಮಗಳು',
            images: KannadaRajyotsavaCulturalActivities2025,
        },
        {
            title: 'ಪವಮಾನ ಹೋಮ',
            date: '23/07/2012',
            category: 'Social Welfare',
            description: '',
            images: pavamanaHomaImages,
        },
        {
            title: 'ಪ್ರತಿಭಾ ಪುರಸ್ಕಾರ',
            date: '2010',
            category: 'Social Welfare',
            description: '',
            images: [],
        },
        {
            title: 'ದಶಲಕ್ಷ ಗಾಯತ್ರಿ ಜಪ ಯಜ್ಞ',
            date: '2013',
            category: 'Festival',
            description: '',
            images: [],
        },
        {
            title: 'ಪ್ರತಿಭಾ ಪುರಸ್ಕಾರ',
            date: '2011',
            category: 'Social Welfare',
            description: '',
            images: [],
        },
        {
            title: 'ಪರ್ಜನ್ಯ ಜಪ ಮತ್ತು ಹೋಮ',
            date: '22/07/2015',
            category: 'Social Welfare',
            description: 'ಮಳೆಗಾಗಿ ಪರಿತಪಿಸುತ್ತಿರುವ  ಚಿಕ್ಕಬಳ್ಳಾಪುರ  ಜಿಲ್ಲೆ ಚಿಂತಾಮಣಿಯಲ್ಲಿ  ನಿನ್ನೆ ಮತ್ತು ಇಂದು ಅಂದರೆ 21 ಮತ್ತು 22 ಜುಲೈ 2015 ತಾರ್ಲೂಕು ಬ್ರಾಹ್ಮಣ ಮಹಾ ಸಭಾ ವತಿಯಿಂದ  ಪರ್ಜನ್ಯ ಜಪ,ಪರ್ಜನ್ಯ ಹೋಮ,ಕುಂಬಾಭಿಷೇಕ, ರುದ್ರ ಹೋಮ ಮತ್ತು ರುದ್ರ ಜಪ ಮುಂತಾದ ಧಾರ್ಮಿಕ ಕಾರ್ಯಕ್ರಮಗಳು ಶ್ರದ್ದಾ ಭಕ್ತಿಗಳಿಂದ ನಗರದ ಅಗ್ರಹಾರದಲ್ಲಿನ  ಸೋಮೇಶ್ವರ  ದೇವಾಲಯದಲ್ಲಿ ನಡೆಯಿತು. ಶೃಂಗೇರಿಯ ಲಕ್ಷ್ಮಣ ಶರ್ಮ ನೇತೃತ್ವದಲ್ಲಿ ನಡೆದ ಈ ಕೈಂಕರ್ಯದಲ್ಲಿ ನೂರಾರು ಜನ ಭಾಗವಹಿಸಿದ್ದರು.',
            images: ParjanyaJapaAndHoma,
        },
        {
            title: 'ವಾರ್ಷಿಕ ಮಹಾಸಭೆ ಮತ್ತು ಪ್ರತಿಭಾ ಪುರಸ್ಕಾರ',
            date: '2012',
            category: 'Social Welfare',
            description: '',
            images: PrathibaPuraskara2012,
        },
        {
            title: 'ಮಹಾರುದ್ರ ಯಾಗ',
            date: '04/01/2015',
            category: 'Social Welfare',
            description: '',
            images: mahaRudraYagaImages,
        },
        {
            title: 'ವಾರ್ಷಿಕ ಮಹಾಸಭೆ ಮತ್ತು ಪ್ರತಿಭಾ ಪುರಸ್ಕಾರ',
            date: '2013',
            category: 'Social Welfare',
            description: '',
            images: PrathibaPuraskara2013,
        },
        {
            title: 'ಶ್ರೀ ರಾಮ ತಾರಕ ಹೋಮ',
            date: '07/06/2016',
            category: 'Social Welfare',
            description: 'ಶ್ರೀ ಬ್ರಹ್ಮ ಚೈತನ್ಯ ಶ್ರೀರಾಮ ಮಂದಿರದಲ್ಲಿ ನಡೆದಶ್ರೀ ರಾಮ ತಾರಕ ಹೋಮದಲ್ಲಿ ಬ್ರಾಹ್ಮಣ ಮಹಾಸಭಾ ವತಿಯಿಂದ ಭಾಗವಹಿಸುವಿಕೆ',
            images: sriRamaTarkaHomaImages,
        },
        {
            title: 'ವಾರ್ಷಿಕ ಮಹಾಸಭೆ ಮತ್ತು ಪ್ರತಿಭಾ ಪುರಸ್ಕಾರ',
            date: '2014',
            category: 'Social Welfare',
            description: '',
            images: PrathibaPuraskara2014,
        },
        {
            title: 'ಉಚಿತ ರಕ್ತದಾನ ಶಿಬಿರ',
            date: '11/12/2013',
            category: 'Social Welfare',
            description: '',
            images: [],
        },
        {
            title: 'ವಾರ್ಷಿಕ ಮಹಾಸಭೆ ಮತ್ತು ಪ್ರತಿಭಾ ಪುರಸ್ಕಾರ',
            date: '2015',
            category: 'Social Welfare',
            description: '',
            images: PrathibaPuraskara2015,
        },
        {
            title: 'ಅಖಿಲ ಕರ್ನಾಟಕ ಬ್ರಾಹ್ಮಣ ಮಹಾಸಭಾ',
            date: '17/06/2012',
            category: 'Social Welfare',
            description: 'ಅಖಿಲ ಕರ್ನಾಟಕ ಬ್ರಾಹ್ಮಣ ಮಹಾಸಭಾದ ಬೆಳಗಾವಿ ರಾಜ್ಯ ಸಮ್ಮೇಳನದಲ್ಲಿ ಚಿಂತಾಮಣಿ ತಾಲ್ಲೂಕು ಬ್ರಾಹ್ಮಣ ಮಹಾಸಭಾ ವತಿಯಿಂದ ಭಾಗವಹಿಸುವಿಕೆ.',
            images: AkhilaKarnatakaBramhanaMahasabha,
        },
        {
            title: 'ವಾರ್ಷಿಕ ಮಹಾಸಭೆ ಮತ್ತು ಪ್ರತಿಭಾ ಪುರಸ್ಕಾರ',
            date: '2016',
            category: 'Social Welfare',
            description: '',
            images: PrathibaPuraskara2016,
        },
        {
            title: 'ಸಚ್ಚಿದಾನಂದ. ಮೂರ್ತಿ ಅಭಿನಂದನಾ ಕಾರ್ಯಕ್ರಮ',
            date: '12/01/2020',
            category: 'Social Welfare',
            description: '',
            images: SachidanadaMurthiAbinandana,
        },
        {
            title: 'ಪ್ರತಿಭಾ ಪುರಸ್ಕಾರ',
            date: '2017',
            category: 'Social Welfare',
            description: '',
            images: [],
        },
        {
            title: 'ಅಧಿಕಾರ ಪದಗ್ರಹಣ',
            date: '23/12/2023',
            category: 'Social Welfare',
            description: 'ಎನ್. ಕೃಷ್ಣ ನೇತೃತ್ವದಲ್ಲಿ ಅಧಿಕಾರ ಪದಗ್ರಹಣ',
            images: AdhikaraPadagrahana,
        },
        {
            title: 'ಪ್ರತಿಭಾ ಪುರಸ್ಕಾರ',
            date: '2018',
            category: 'Social Welfare',
            description: '',
            images: [],
        },
        {
            title: 'ಕನ್ನಡ ರಾಜ್ಯೋತ್ಸವ ಮತ್ತು ಕ್ಯಾಲೆಂಡರ್ ಬಿಡುಗಡೆ',
            date: 'Nov 30, 2024',
            category: 'Cultural',
            description: '',
            images: KannadaRajyotsavaAndCalendarRelease2024,
        },
        {
            title: 'ಪ್ರತಿಭಾ ಪುರಸ್ಕಾರ',
            date: '2019',
            category: 'Social Welfare',
            description: '',
            images: [],
        },
        {
            title: 'AKBMS ಸುವರ್ಣ ಸಂಭ್ರಮ "ವಿಶ್ವಾಮಿತ್ರ"',
            date: 'ಜನವರಿ 18, 19 2025',
            category: 'Youth',
            description: '@ಬೆಂಗಳೂರು',
            images: AKBMSSuvarnaSambhramaVishwamitra,
        },
        {
            title: 'ಪ್ರತಿಭಾ ಪುರಸ್ಕಾರ',
            date: '2020',
            category: 'Social Welfare',
            description: '',
            images: [],
        },
        {
            title: 'ಮಾಘ ಸ್ನಾನ',
            date: '17/02/2024',
            category: 'Social Welfare',
            description: '@ರಾಮನಾಥಪುರ ಸುತ್ತ ಮುತ್ತ',
            images: MaghaSnana2024,
        },
        {
            title: 'ಪ್ರತಿಭಾ ಪುರಸ್ಕಾರ',
            date: '2021',
            category: 'Social Welfare',
            description: '',
            images: [],
        },
        {
            title: 'ಮಾಘಸ್ನಾನ',
            date: '02/02/2025',
            category: 'Wellness',
            description: '@ಹರಿಹರಪುರ',
            images: Maghasnana2025,
        },
        {
            title: 'ಪ್ರತಿಭಾ ಪುರಸ್ಕಾರ',
            date: '2022',
            category: 'Social Welfare',
            description: '',
            images: [],
        },
        {
            title: 'ಮಹಾರುದ್ರ ಪಾರಾಯಣ',
            date: '19/05/2024',
            category: 'Educational',
            description: 'ಶ್ರೀ ಶಾರದಾ ಶಂಕರ ಪ್ರಾರ್ಥನಾ ಮಂದಿರ ಚಿಂತಾಮಣಿ',
            images: MahaRudraParayana,
        },
        {
            title: 'ಪ್ರತಿಭಾ ಪುರಸ್ಕಾರ',
            date: '2023',
            category: 'Social Welfare',
            description: '',
            images: [],
        },
        {
            title: 'ಅರುಣ ಹೋಮ',
            date: 'ಜುಲೈ 06 ಮತ್ತು 07 2024',
            category: 'Festival',
            description: '',
            images: ArunaHoma2024,
        },
        {
            title: 'ಪ್ರತಿಭಾ ಪುರಸ್ಕಾರ',
            date: '2024',
            category: 'Social Welfare',
            description: '',
            images: [],
        },
        {
            title: 'ಸಂಘದ ವಾರ್ಷಿಕ ಮಹಾಸಭೆ.',
            date: '2024',
            category: 'Social Welfare',
            description: '',
            images: [],
        },
        {
            title: 'ವಾರ್ಷಿಕ ಮಹಾಸಭೆ ಮತ್ತು ಪ್ರತಿಭಾ ಪುರಸ್ಕಾರ',
            date: '2025',
            category: 'Social Welfare',
            description: '',
            images: PrathibaPuraskara2025,
        },
        {
            title: 'ಸಂಘದ ಕಚೇರಿ ಉದ್ಘಾಟನೆ',
            date: '29/09/2024',
            category: 'Social Welfare',
            description: '',
            images: SangadaVarshikaMahasabhi,
        },
        {
            title: 'ಡೈರೆಕ್ಟರಿ ಬಿಡುಗಡೆ',
            date: '2022',
            category: 'Social Welfare',
            description: 'ಬ್ರಾಹ್ಮಣ ಮಹಾಸಭಾ ವತಿಯಿಂದ ತಾಲ್ಲೂಕಿನ ಎಲ್ಲ ವಿಪ್ರ ಬಂಧುಗಳ ಡೈರೆಕ್ಟರಿ ಬಿಡುಗಡೆ',
            images: [],
        },
        {
            title: 'ಮಹಿಳಾ ಸಮ್ಮೇಳನ  ಅಭಿಜಾತೆ',
            date: '07/01/2024',
            category: 'Social Welfare',
            description: 'ಅಖಿಲ ಕರ್ನಾಟಕ ಬ್ರಾಹ್ಮಣ ಮಹಾಸಭಾದ ವತಿಯಿಂದ 3ನೇ ರಾಜ್ಯಮಟ್ಟದ ಮಹಿಳಾ ಸಮ್ಮೇಳನ  ಅಭಿಜಾತೆ ಬೆಂಗಳೂರಿನ ಶಂಕರಪುರಂ ನಲ್ಲಿ ಆಯೋಜಿಸಲಾಗಿತ್ತು. ಚಿಂತಾಮಣಿಯಿಂದ ಸುಮಾರು 60 ಮಂದಿ ಪಾಲ್ಗೊಂಡಿದ್ದರು.',
            images: MahilaSammelanaAbhijathe,
        },
    ];

    const eventCategories = [
        { name: 'All Events', count: upcomingEvents.length + pastEvents.length },
        { name: 'Past Events', count: pastEvents.length },
        { name: 'Upcoming Events', count: upcomingEvents.length },
    ];

    return (
        <div className="pt-40">
            <section className="relative py-20 bg-gradient-to-br from-[#060771] to-[#BF1A1A] text-white">
                <div className="container mx-auto px-4">
                    <div className="max-w-4xl mx-auto text-center">
                        {/* <div className="inline-block px-4 py-2 bg-[#FFE08F] rounded-full mb-6">
                            <span className="text-[#060771]">ಕಾರ್ಯಕ್ರಮಗಳು</span>
                        </div> */}
                        <h1 className="text-4xl md:text-5xl lg:text-6xl mb-6">
                            ಕಾರ್ಯಕ್ರಮಗಳು
                        </h1>
                        <p className="text-xl md:text-2xl text-white/90">
                            ನಮ್ಮ ಮುಂದಿನ ಮತ್ತು ಹಳೆಯ ಕಾರ್ಯಕ್ರಮಗಳ ಪಟ್ಟಿ
                        </p>
                    </div>
                </div>
            </section>

            <section className="py-20 bg-white">
                <div className="container mx-auto px-4">
                    {/* Tabs for Event Categories */}
                    <Tabs defaultValue="past" className="mb-12">
                        <TabsList className="grid w-full max-w-md mx-auto grid-cols-2 mb-12">
                            <TabsTrigger value="past">Past Events ({pastEvents.length})</TabsTrigger>
                            <TabsTrigger value="upcoming">Upcoming Events ({upcomingEvents.length})</TabsTrigger>
                        </TabsList>

                        <TabsContent value="past">
                            {/* Past Events Grid */}
                            <div className="grid md:grid-cols-2 lg:grid-cols-2 gap-6">
                                {pastEvents.map((event, index) => (
                                    <Card key={index} className="p-6 hover:shadow-lg transition-shadow border-l-4 border-l-[#FF6C0C]">
                                        <div className="relative h-48 overflow-hidden">
                                            <Carousel className="w-full h-full">
                                                <CarouselContent>
                                                    {event.images.map((image: any, imgIndex: any) => (
                                                        <CarouselItem key={imgIndex}>
                                                            {/* Expand Button */}
                                                            <button
                                                                onClick={() => openFullscreen(event.images)}
                                                                className="absolute top-2 right-2 z-20 bg-white/80 p-2 rounded-full shadow"
                                                            >
                                                                <Maximize2 size={18} className="text-black" />
                                                            </button>
                                                            <ImageWithFallback
                                                                src={image}
                                                                alt={`${event.title} - Image ${imgIndex + 1}`}
                                                                className="w-full h-48 object-fill rounded-md"
                                                                style={{ objectFit: "contain" }}
                                                            />
                                                        </CarouselItem>
                                                    ))}
                                                </CarouselContent>
                                                {event.images.length > 1 && (
                                                    <>
                                                        <CarouselPrevious className="absolute left-2 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white text-[#4A0404] border-none h-8 w-8" />
                                                        <CarouselNext className="absolute right-2 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white text-[#4A0404] border-none h-8 w-8" />
                                                    </>
                                                )}
                                            </Carousel>
                                        </div>
                                        <h3 className="text-xl text-[#060771] mb-2">{event.title}</h3>
                                        <p className="text-sm text-gray-500 mb-3">{event.date}</p>
                                        <p className="text-gray-600">{event.description}</p>
                                    </Card>
                                ))}
                            </div>
                        </TabsContent>

                        <TabsContent value="upcoming">
                            {/* Upcoming Events Grid */}
                            <div className="grid md:grid-cols-2 lg:grid-cols-2 gap-8">
                                {upcomingEvents.map((event, index) => (
                                    <Card key={index} className="overflow-hidden hover:shadow-xl transition-shadow group flex flex-col border-l-4 border-l-[#FF6C0C]">
                                        <div className="p-6 flex-1 flex flex-col">
                                            <h3 className="text-2xl text-[#060771] mb-3">{event.title}</h3>
                                            <p className="text-gray-600 mb-4">{event.description}</p>

                                            <div className="space-y-2 mb-4">
                                                <div className="flex items-center text-gray-700">
                                                    <Calendar className="h-4 w-4 mr-2 text-[#FF6C0C]" />
                                                    <span>{event.date}</span>
                                                </div>
                                                <div className="flex items-center text-gray-700">
                                                    <Clock className="h-4 w-4 mr-2 text-[#FF6C0C]" />
                                                    <span>{event.time}</span>
                                                </div>
                                                <div className="flex items-center text-gray-700">
                                                    <MapPin className="h-4 w-4 mr-2 text-[#FF6C0C]" />
                                                    <span>{event.location}</span>
                                                </div>
                                                <div className="flex items-center text-gray-700">
                                                    <Users className="h-4 w-4 mr-2 text-[#FF6C0C]" />
                                                    <span>{event.attendees}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </Card>
                                ))}
                            </div>
                        </TabsContent>
                    </Tabs>
                </div>
            </section>
            {/* ---- FULLSCREEN IMAGE MODAL ---- */}
            <FullscreenImageModal
                open={openModal}
                onClose={() => setOpenModal(false)}
                images={selectedImages}
            />
        </div>
    );
}
export default EventsComponent;